import loginBksApi from "./room/login.js";
import systemBksApi from "./system/system.js";
import roomBksApi from "./room/room.js";

export default {
  loginBksApi,
  systemBksApi,
  roomBksApi
};
